// top-level imports
import React from 'react';
import Button from 'components/common/Button';
import SessionCategoryInput from 'components/inputs/SessionCategoryInputLegacy';
import DateInput from 'components/inputs/DateInput';
import TextInput from 'components/inputs/TextInput';
import TextAreaInput from 'components/inputs/TextAreaInput';
import FormItem from 'components/common/FormItem';
// COMPONENTS
import styled from 'styled-components';
// add plan _id
// add dashboards

const ButtonContainer = styled.div`
  text-align: center;
  margin-top: 10px;
`;

export class ClientInviteForm extends React.Component {
  state = {
    firstName: '',
    lastName: '',
    venue: '',
    email: '',
    message: '',
    phone: '',
    eventDate: '',
  };

  onChange = newValue => {
    console.log(newValue);
    this.setState(newValue);
  };

  onSubmit = e => {
    e.preventDefault();
    this.props.handleSubmit(this.state);
  };

  render() {
    const { contactForm } = this.props;

    return (
      <form onSubmit={this.onSubmit} style={{ width: 400, maxWidth: '90%', margin: 'auto', textAlign: 'left' }}>
        {contactForm.firstName && (
          <FormItem label="First Name">
            <TextInput value={this.state.firstName} onChange={firstName => this.onChange({ firstName })} />
          </FormItem>
        )}
        {contactForm.lastName && (
          <FormItem label="Last Name">
            <TextInput value={this.state.lastName} onChange={lastName => this.onChange({ lastName })} />
          </FormItem>
        )}
        {contactForm.email && (
          <FormItem label="Email">
            <TextInput value={this.state.email} onChange={email => this.onChange({ email })} />
          </FormItem>
        )}
        {contactForm.message && (
          <FormItem label="Message">
            <TextInput value={this.state.message} onChange={message => this.onChange({ message })} />
          </FormItem>
        )}
        {contactForm.phone && (
          <FormItem label="Phone">
            <TextInput value={this.state.phone} onChange={phone => this.onChange({ phone })} />
          </FormItem>
        )}
        {contactForm.eventDate && (
          <FormItem label="Session Date">
            <DateInput value={this.state.eventDate} onChange={eventDate => this.onChange({ eventDate })} />
          </FormItem>
        )}
        {contactForm.eventType &&
          this.props.organization &&
          this.props.organization.sessionTypes &&
          this.props.organization.sessionTypes.length > 0 && (
            <FormItem label="Session Type">
              <SessionCategoryInput
                sessionTypes={this.props.organization.sessionTypes}
                value={this.state.category}
                onChange={category => this.onChange({ category })}
              />
            </FormItem>
          )}
        {contactForm.whereDidYouHearAboutUs && (
          <FormItem label="Where did you hear about us?" hasFeedback>
            <TextAreaInput
              value={this.state.whereDidYouHearAboutUs}
              onChange={e => this.onChange({ whereDidYouHearAboutUs: e.target.value })}
            />
          </FormItem>
        )}
        <ButtonContainer>
          <Button loading={this.props.loading} disabled={this.props.loading} fullWidth htmlType="submit">
            SUBMIT
          </Button>
        </ButtonContainer>
      </form>
    );
  }
}

export default ClientInviteForm;



// WEBPACK FOOTER //
// ./src/components/forms/ClientInviteForm/index.js